import RestClient from '../RestClient/RestClient';

const getWeeklyAdDetail = (weeklyAdsStoreCode) => {
    try {
        // default store code/id for weekly ads to fetch referred from Marketing page which is Manhattan Mall (store id = 0174)
        const DEFAULT_WEEKLY_ADS_STORE_CODE = '0174';
        const { storeCode = DEFAULT_WEEKLY_ADS_STORE_CODE } = weeklyAdsStoreCode.payload || {};
        const config = {
            url: `https://api.flipp.com/flyerkit/v4.0/publications/jcpenney?access_token=f3c9f734608041844455a45c431a0655&locale=en-US&store_code=${storeCode}`,
            external: true,
        };
        return RestClient.get(config).then((json) => json);
    } catch (e) {
        /* istanbul ignore next */
        return e;
    }
};

export default getWeeklyAdDetail;
